import {ACTIVE_TYPE, ENUM_TYPE, LABELS_TYPE, SELECT_TYPE, TEXT_TYPE, LOCAL_DATE_TIME} from './columnTypes';

export const rolesColumns = [
    {
        name: 'name',
        displayNameKey: 'name',
        type: TEXT_TYPE
    },
    {
        name: 'usersCount',
        displayNameKey: 'usersCount',
        type: TEXT_TYPE,
        notSortAndFilter: true
    },
    {
        name: 'permissions',
        displayNameKey: 'permissions',
        type: LABELS_TYPE,
        notSortAndFilter: true
    },
    {
        name: 'companyId',
        displayNameKey: 'companyId',
        type: SELECT_TYPE,
        source: 'companies',
    },
    {
        name: 'editUserId',
        displayNameKey: 'editUserId',
        filterType: SELECT_TYPE,
        source: "users",
        type: SELECT_TYPE
    },
    {
        name: 'createUserId',
        displayNameKey: 'createUserId',
        filterType: SELECT_TYPE,
        source: "users",
        type: SELECT_TYPE
    },
    {
        name: 'editDate',
        displayNameKey: 'editDate',
        filterType: LOCAL_DATE_TIME,
        type: LOCAL_DATE_TIME
    },
    {
        name: 'createDate',
        displayNameKey: 'createDate',
        filterType: LOCAL_DATE_TIME,
        type: LOCAL_DATE_TIME
    },
    {
        name: 'isActive',
        displayNameKey: 'isActive',
        type: ACTIVE_TYPE,
    },
];
